import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStatePartnerDashboard = {
  partnerDashboard: { data: null, loading: false, error: null },
};

export const partnerDashboard = createAsyncThunk('user/partnerDashboard', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/partner/dashboard`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerPartnerDashboard = {
  [partnerDashboard.pending]: (state) => {
    state.partnerDashboard.loading = true;
  },
  [partnerDashboard.fulfilled]: (state, action) => {
    state.partnerDashboard.loading = false;
    state.partnerDashboard.data = action.payload;
    state.partnerDashboard.error = null;
  },
  [partnerDashboard.rejected]: (state, action) => {
    state.partnerDashboard.loading = false;
    state.partnerDashboard.error = action.payload;
  },
};
